<h2 class="header-model-product" mat-dialog-title>Session Expiration</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <h3>Your session is about to expire. Do you want to stay signed in?</h3>
</mat-dialog-content>
<mat-dialog-actions align="center" class="dialog-actions">
  <button mat-button class="primary-btn"  (click)="onStay()">Stay Signed In</button>
  <button mat-button class="secondary-btn" cdkFocusInitial (click)="onLogout()">Log Out</button>
</mat-dialog-actions>
